var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3081 8.55066C27.1633 7.84369 25.9429 7.5 24.5771 7.5C22.9429 7.5 21.3389 7.99527 19.7877 8.47424C18.2723 8.94214 16.8409 9.38409 15.4242 9.38424C15.424 9.38424 15.4238 9.38424 15.4236 9.38424C14.4765 9.38424 13.6187 9.17786 12.8141 8.75541V8.26172C12.8141 7.84105 12.4827 7.5 12.074 7.5C11.6653 7.5 11.334 7.84105 11.334 8.26172V9.20381V19.5579V32.7383C11.334 33.159 11.6653 33.5 12.074 33.5C12.4827 33.5 12.8141 33.159 12.8141 32.7383V20.7769C13.6314 21.1019 14.4941 21.2617 15.4242 21.2617C17.0583 21.2617 18.6622 20.7664 20.2133 20.2875C21.7288 19.8195 23.1602 19.3775 24.5771 19.3775C25.667 19.3775 26.6383 19.6502 27.5465 20.2111C27.7751 20.3522 28.0598 20.356 28.2919 20.2208C28.5239 20.0856 28.6673 19.8323 28.6673 19.5579V9.20381C28.6673 8.93625 28.5309 8.68828 28.3081 8.55066Z",
    fill: "#F44A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintIcon);
export default __webpack_public_path__ + "static/media/complaintIcon.573b207a.svg";
export { ForwardRef as ReactComponent };